var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGraphIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 167,
    height: 166,
    viewBox: "0 0 167 166",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M156.612 83.4001C156.612 67.8151 151.684 52.6301 142.535 40.0215C133.385 27.413 120.483 18.0282 105.679 13.2121C90.8744 8.39609 74.927 8.39609 60.1225 13.2121C45.318 18.0282 32.4163 27.413 23.2667 40.0215C14.117 52.6301 9.18896 67.8151 9.18896 83.4001C9.18897 98.9851 14.117 114.17 23.2667 126.779C32.4164 139.387 45.318 148.772 60.1225 153.588C74.927 158.404 90.8744 158.404 105.679 153.588L82.9007 83.4001H156.612Z",
    fill: "#FA6C51"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M167 91.4C167 106.985 162.072 122.17 152.922 134.779C143.773 147.387 130.871 156.772 116.066 161.588L93.2883 91.4L167 91.4Z",
    fill: "#70D9B8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M132.782 16.706C144.747 25.7302 154.046 37.8316 159.691 51.7239L82.9008 83L132.782 16.706Z",
    fill: "#EBBF44"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.40715 114.995C1.36175 102.904 -0.752429 89.7884 0.237591 76.7218C1.22761 63.6553 5.2937 51.0091 12.1031 39.8181L82.9008 83L6.40715 114.995Z",
    fill: "#6CBF84"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphIcon);
export default __webpack_public_path__ + "static/media/graph-icon.d545e98728973239da52f7eaf22a5833.svg";
export { ForwardRef as ReactComponent };